import Cookies from 'universal-cookie';
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

export const ForwardThinkingLandingRedirect = () => {
  const cookies = new Cookies();
  cookies.set('last_landing_rule', '/forwardthinking', { domain: cookieDomain });
  cookies.set('landing_page', '/forwardthinking', { domain: cookieDomain });
  window.location = '/';
  return null;
};
